<!-- eslint-disable vue/html-self-closing -->
<template>
  <div
    :class="[$style['ua-schools-list__item']]">
    <span 
      :class="[testClass('school-name')]">
      {{ school.name }}
    </span>

    <sl-tooltip :content="removeSchoolLabel" :class="testClass('tooltip')">
      <sl-icon-button
        :disabled="school.active_enrollment_for_current_user"
        name="minus-circle"
        library="default"
        type="button"
        :class="[$style['ua-schools-list__edit-button'], $style['ua-schools__edit-icon'], testClass('delete-button')]"
        @click.prevent="showDeleteConfirm()">
      </sl-icon-button>
    </sl-tooltip>
  </div>
  
  <music-dialog-v3 ref="deleteSchoolDialogRef" heading="Remove School">
    Are you sure you want to delete this school from your account?
    <div slot="footer">
      <form 
        accept-charset="UTF-8"
        :action="school.delete_path"
        method="post">
        <l-spanner-v3>
          <input
            type="hidden"
            name="_method"
            value="delete"
            autocomplete="off">
          <input 
            type="hidden"
            name="authenticity_token"
            :value="authToken"
            autocomplete="off" />

          <button 
            type="button"
            :class="testClass('no-button')"
            class="c-button-v3  c-button-v3--secondary"
            @click.prevent="deleteSchoolDialogRef.closeModal();">
            No
          </button>
          <button 
            type="submit"
            :class="testClass('yes-button')"
            class="c-button-v3  c-button-v3--primary">
            Yes
          </button>
        </l-spanner-v3>
      </form>
    </div>
  </music-dialog-v3>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { testClass } from 'music';
  import { default as authToken } from '~/src/shared/lib/auth_token.js'

  const props = defineProps({
    school: {
      type: Object,
      default() {
        return {}
      },
    }
  });
  const deleteSchoolDialogRef = ref(null);

  const showDeleteConfirm = () => {
    deleteSchoolDialogRef.value.showModal();
  }

  const removeSchoolLabel = computed(() => {
    if (props.school.active_enrollment_for_current_user) {
      return 'You cannot remove a school if you are actively enrolled in a course at that school.';
    }

    return `Remove School ${props.school.name}`;
  });
</script>

<style lang="scss" module>
  @use 'music/app/styles/library/base' as * ;
  
  .ua-schools-list__item {
    font-weight: var(--music-font-bold);
    text-align: left;
    color: var(--music-true-gray-900, #1D1D1D);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ua-schools-list__edit-button {
    --sl-input-height-medium: 1rem;
    --sl-input-border-width: 0;
    font-size: var(--music-font-heading-4, 1.5rem);

    &::part(base) {
      background-color: unset;
      color: var(--music-widget-red-700);
      padding: 0 0 0 var(--sl-spacing-x-small);
    }

    &::part(label) {
      --sl-spacing-medium: 0;
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

</style>
